<template>
  <div>
    <div class="headline5 mb-3">
      {{ $t("modals.createWorkspace.brandingSettings") }}
    </div>
    <div class="mt-3 mb-4 px-3 py-1 info-block">
      <v-icon size="24" icon="$info" />
      <span class="body2 ml-2">
        {{ $t("modals.editWorkspace.branding.infoBlock") }}
      </span>
    </div>
    <div class="d-flex justify-space-between w-100">
      <v-card height="610px" width="818px" class="mr-5">
        <v-card-text class="pb-4 pt-4">
          <cui-branding-fields
            v-model="workspace.branding"
            :labels="brandingLabels"
            :rules="brandingRules"
            :no-reply-domain="brandingNoReplyDomain"
            :alias-disabled="aliasDisabled"
            test-id-prefix="create-workspace-modal"
          />
        </v-card-text>
      </v-card>

      <v-card width="306px" height="610px">
        <v-card-text>
          <div class="subtitle1 mt-2">
            {{ $t("modals.createWorkspace.replaceCoroIcons") }}
          </div>
          <cui-branding-logos
            class="d-flex flex-column align-center justify-center mt-4 mb-4"
            :header-icon-url="workspace.branding.headerIconUrl"
            :email-icon-url="workspace.branding.emailIconUrl"
            :brand-color="workspace.branding.brandColor"
            :default-logos="defaultLogos"
            :labels="logosLabels"
            test-id-prefix="create-workspace-modal"
            @image-changed="workspace.image = $event"
            @email-image-changed="workspace.emailImage = $event"
          />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { CuiBrandingFields, type CuiBrandingFieldsRules, CuiBrandingLogos } from "@coronet/cui";
import type { MspWorkspaceDialogItem } from "@/_store/msp/msp.module.ts";
import { useMspWorkspaceModal } from "@/composables/useMspWorkspaceModal";
import { useWorkspaceFormText } from "@/composables/useWorkspaceFormText";
import { BRANDING_DEFAULT_LOGOS, BRANDING_NO_REPLY_DOMAIN } from "@/constants/general.ts";

/** Branding step of the MSP create-workspace wizard (Channel workspaces); edits the item in place. */
export default defineComponent({
  components: { CuiBrandingFields, CuiBrandingLogos },
  props: {
    workspace: {
      type: Object as PropType<MspWorkspaceDialogItem>,
      required: true,
    },
    /** Only a global admin may set the subdomain alias. */
    aliasDisabled: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const { brandColorRules, aliasRules, supportEmailRules } = useMspWorkspaceModal();
    const { brandingLabels, logosLabels } = useWorkspaceFormText();
    const brandingRules: CuiBrandingFieldsRules = {
      brandColorRules,
      aliasRules,
      supportEmailRules,
    };

    return {
      brandingRules,
      brandingLabels,
      logosLabels,
      brandingNoReplyDomain: BRANDING_NO_REPLY_DOMAIN,
      defaultLogos: BRANDING_DEFAULT_LOGOS,
    };
  },
});
</script>

<style lang="scss" scoped>
// The dialog's `.stepper-step__wrapper .v-card` rule reaches only cards in its own template.
.v-card {
  border-radius: 8px !important;
}
</style>
